(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function cleanSizeLabels(root) {
    if (!root || typeof document.createTreeWalker !== 'function') {
      return;
    }

    var pattern = /^(\d{2,3})\s*\(EU\s*\d{2,3}\)$/i;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      var trimmed = node.nodeValue.trim();
      var match = trimmed.match(pattern);

      if (match) {
        node.nodeValue = node.nodeValue.replace(trimmed, match[1]);
      }
    }
  }

  function cleanProductSizeLabels(root) {
    if (!window.theme || window.theme.pageType !== 'product') {
      return;
    }

    var scopeRoot = root && root.querySelectorAll ? root : document;
    var scopes = scopeRoot.querySelectorAll('.ProductForm, .Product__Info, .ProductMeta, .ProductTabs, .Popover, .Drawer');

    if (!scopes.length && scopeRoot.body) {
      cleanSizeLabels(scopeRoot.body);
      return;
    }

    scopes.forEach(cleanSizeLabels);
  }

  function setupStickyAddToCart() {
    if (!window.theme || window.theme.pageType !== 'product') {
      return;
    }

    if (!window.matchMedia || !window.matchMedia('(max-width: 999px)').matches) {
      return;
    }

    if (document.querySelector('[data-dicorya-sticky-add-to-cart]')) {
      return;
    }

    var mainButton = document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart');

    if (!mainButton) {
      return;
    }

    var priceEl = document.querySelector('[data-dicorya-price]');
    var bar = document.createElement('div');
    var price = document.createElement('span');
    var buttonClone = mainButton.cloneNode(true);

    bar.className = 'DicoryaStickyBar';
    bar.setAttribute('data-dicorya-sticky-add-to-cart', '');
    price.className = 'DicoryaStickyBar__Price';
    price.textContent = priceEl ? priceEl.textContent.trim() : '';
    buttonClone.removeAttribute('id');

    bar.appendChild(price);
    bar.appendChild(buttonClone);
    document.body.appendChild(bar);

    buttonClone.addEventListener('click', function (event) {
      event.preventDefault();
      mainButton.click();
    });

    document.addEventListener('variant:changed', function () {
      var updatedPrice = document.querySelector('[data-dicorya-price]');

      if (updatedPrice) {
        price.textContent = updatedPrice.textContent.trim();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });

      observer.observe(mainButton);
    }
  }

  onReady(function () {
    cleanProductSizeLabels(document);
    setupStickyAddToCart();
  });

  document.addEventListener('shopify:section:load', function (event) {
    cleanProductSizeLabels(event.target);
  });
}());
